export default "__VITE_ASSET__4Smk4EyG__"